"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleLocationInSet = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
/**
 * @param {Set} selectedLocationIds
 * @param {String} id
 * @returns {Set}
 */
const toggleLocationInSet = (selectedLocationIds, id) => {
  const updates = new _set.default(selectedLocationIds);
  if (id != null) {
    updates.has(id) ? updates.delete(id) : updates.add(id);
  }
  return updates;
};
exports.toggleLocationInSet = toggleLocationInSet;